// extracted by mini-css-extract-plugin
export default {"code":"CodeEditor_code__VDj1o","disabled":"CodeEditor_disabled__7X9a4"};